
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Curevac est une start-up spécialisée dans l’ARN messager basée à Tübingen
(Allemagne). Elle a passé des accords avec des grands groupes pharmaceutiques
pour soutenir la production et la commercialisation de son produit CVnCoV.
Celui-ci a été le premier à susciter de grands espoirs dans le monde. Au point
qu'en 2020, le président Donald Trump a tenté d'attirer la petite entreprise aux
Etats-Unis.`}</p>
    <p>{`Des essais cliniques de phase III ont débuté en Allemagne en décembre 2020.
`}<a parentName="p" {...{
        "href": "https://www.bag.admin.ch/bag/fr/home/das-bag/aktuell/medienmitteilungen.msg-id-82224.html"
      }}>{`La Suisse a commandé 5 millions de doses`}</a>{`
et en avril 2021, Curevac a soumis une
`}<a parentName="p" {...{
        "href": "https://www.swissmedic.ch/swissmedic/fr/home/news/coronavirus-covid-19/zlgesuch-covid-19-impfstoff-cvncov.html"
      }}>{`demande d’autorisation à Swissmedic`}</a>{`.`}</p>
    <p>{`Mais alors que les autres vaccins à ARN messager (ceux de Pfizer/BioNTech et de
Moderna) ont montré de bons résultats contre le Covid-19, celui-ci n'a pas tenu
ses promesses. Le projet a pris du retard. Surtout, les résultats définitifs de
l'étude clinique à grande échelle ont révélé début juillet que l'efficacité
n'était que de 48%. Le seuil minimal fixé par l'OMS est de 50%.`}</p>
    <p>{`Suite à cette douche froide, le laboratoire allemand a annoncé le 12 octobre
2021
`}<a parentName="p" {...{
        "href": "https://www.curevac.com/en/2021/10/12/curevac-to-shift-focus-of-covid-19-vaccine-development-to-second-generation-mrna-technology/"
      }}>{`l'abandon du développement de son premier candidat-vaccin`}</a>{`.
La start-up se concentre désormais sur une nouvelle version, CV2CoV, qui tient
davantage compte des variants.`}</p>
    <p>{`Curevac y travaille avec le Britannique GlaxoSmithKline (GSK). Les deux firmes
veulent lancer une étude clinique "dans les prochains mois". Cette nouvelle a
mis fin à l'accord de pré-commandes (405 millions de doses) passé avec l'Union
européenne. Des discussions se poursuivent néanmoins avec Bruxelles sur la
deuxième génération de vaccin. L'objectif est désormais d'obtenir une
homologation courant 2022.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;